import { FaUsers, FaQuestion, FaSubscript, FaCreditCard } from "react-icons/fa/index.esm";
import { PiFlagBannerFill } from "react-icons/pi/index.esm";
import { FaCalendarAlt } from "react-icons/fa/index.esm";
import {
  MdPrivacyTip,
  MdAnalytics,
} from "react-icons/md/index.esm";
import { TbInfoTriangleFilled } from "react-icons/tb/index.esm";
import {  RiAdminFill } from "react-icons/ri/index.esm";
import {  GiShop} from "react-icons/gi/index.esm";
import { IoNewspaperSharp } from "react-icons/io5/index.esm";
import Login from "../../pages/Auth/Login";
import ForgotPassword from "../../pages/Auth/ForgotPassword";
import ResetPassword from "../../pages/Auth/ResetPassword";
import UserDetails from "../../pages/UserDetails";
import Admins from "../../pages/Admins";
import AdminCategory from "../../pages/AdminCategory";
import CoachHistory from "../../pages/CoachHistory";
import Banners from "../../pages/Banners";
import PrivacyPolicies from "../../pages/PrivacyPolicies";
import Users from "../../pages/Users";
import CreateRole from "../../pages/CreateRole";
import Chat from "../../pages/Chat";
import AccountSettings from "../../pages/AccountSettings";
import ChangePassword from "../../pages/ChangePassword";
import Faq from "../../pages/Faq"
import ProductCategories from "../../pages/ProductCategories";
import NotificationPage from "../../pages/Notification";
import Dashboard from "../../pages/Dashboard";
import HelpCenter from "../../pages/HelpCenter";
import { MdOutlineHelpCenter, MdSubscriptions } from "react-icons/md";
import CategorySubcategory from "../../pages/CategorySubcategory";
import { BiCategory } from "react-icons/bi";
import TermConditions from "../../pages/TermConditions";
import Subscriptions from "../../pages/Subscriptions";

export default [
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    isAuthenticated: false,
  },
  {
    path: "/login",
    component: <Login />,
    isAuthenticated: false,
  },
  
  {
    path: "/resetpasswords",
    component: <ResetPassword />,
    isAuthenticated: false,
  },
  {
    path: "/settings",
    component: <AccountSettings />,
    isAuthenticated: true,
  },
  {
    path: "/password",
    component: <ChangePassword />,
    isAuthenticated: true,
  },
  {
    link: "/dashboard?requestType=Today",
    icon: <MdAnalytics size={18} />,
    path: "/dashboard",
    component: <Dashboard />,
    isAuthenticated: true,
    label: "Dashboard",
    permission: "dashboard",
  },
  {
    link: "/users?page=1",
    icon: <FaUsers size={18} />,
    path: "/users",
    component: <Users />,
    isAuthenticated: true,
    label: "User Management",
    permission: "user management",
  },

  ,
  // {
  //   link: "/Categories",
  //   icon: <FaUsers size={18} />,
  //   path: "/Categories",
  //   component: <Categories/>,
  //   isAuthenticated: true,
  //   label: "Category",
  //   permission: "Category",

  // },

  // {
  //   link: "/Subcategories",
  //   icon: <FaUsers size={18} />,
  //   path: "/Subcategories",
  //   component: <Subcategories/>,
  //   isAuthenticated: true,
  //   label: "Subcategory",
  //   permission: "Subcategory",

  // },
  // {
  //   link: "/salons/images",
  //   icon: <GiSaloon size={18} />,
  //   path: "/salons/images",
  //   component: <Images />,
  //   isAuthenticated: true,
  //   label: "Salons",
  // },
  {
    path: "/users/:id",
    component: <UserDetails />,
    isAuthenticated: true,
    label: "userdetails",
    permission: "user management",
  },
  {
    link: "/admincategory",
    icon: <FaUsers size={18} />,
    path: "/AdminCategory",
    component: <AdminCategory />,
    isAuthenticated: true,
    label: "Admin Category",
    permission: "Admin Category",
  },
  // {
  //   link: "/appointments?page=1&requestType=Completed&search=",
  //   icon: <FaCalendarAlt size={14} />,
  //   path: "/appointments",
  //   component: <Appointments />,
  //   isAuthenticated: true,
  //   label: "Booking List",
  //   permission: "booking_list",
  // },
  // {
  //   link: "/orders?page=1&requestType=All&search=",
  //   icon: <GiShoppingBag size={14} />,
  //   path: "/orders",
  //   component: <Orders />,
  //   isAuthenticated: true,
  //   label: "Order List",
  //   permission: "order_list",
  // },
  // {
  //   link: "/product-promocodes",
  //   icon: <RiCoupon3Fill size={14} />,
  //   path: "/product-promocodes",
  //   component: <ProductPromocodes />,
  //   isAuthenticated: true,
  //   label: "Product Promocodes",
  //   permission: "product_promocodes",
  // },
  {
    link: "/admins?page=1",
    icon: <RiAdminFill size={18} />,
    path: "/admins",
    component: <Admins />,
    isAuthenticated: true,
    label: "Admins",
    permission: "admins",
  },
  // {
  //   link: "/blog-categories",
  //   icon: <TbCategoryFilled size={14} />,
  //   path: "/blog-categories",
  //   component: <BlogCategories />,
  //   isAuthenticated: true,
  //   label: "Blog Categories",
  //   permission: "blogs",
  // },
  // {
  //   link: "/blogs?page=1",
  //   icon: <IoNewspaperSharp size={14} />,
  //   path: "/blogs",
  //   component: <Blogs />,
  //   isAuthenticated: true,
  //   label: "Blogs",
  //   permission: "blogs",
  // },
  {
    link: "/product-categories",
    icon: <GiShop size={14} />,
    path: "/product-categories",
    component: <ProductCategories />,
    isAuthenticated: true,
    label: "Product Categories",
    permission: "product_categories",
  },
  // {
  //   link: "/tips-tricks?page=1",
  //   icon: <MdTipsAndUpdates size={14} />,
  //   path: "/tips-tricks",
  //   component: <TipsAndTricks />,
  //   isAuthenticated: true,
  //   label: "Tips And Tricks",
  //   permission: "tips_tricks",
  // },
  {
    link: "/banner?page=1",
    icon: <PiFlagBannerFill size={18} />,
    path: "/banner",
    component: <Banners />,
    isAuthenticated: true,
    label: "Planner Banner",
    permission: "banner",
  },
  {
    link: "/privacy-policies?page=1",
    icon: <MdPrivacyTip size={14} />,
    path: "/privacy-policies",
    component: <PrivacyPolicies />,
    isAuthenticated: true,
    label: "Privacy Policies",
    permission: "privacy policies",
  },
  {
    link: "/term-and-conditions",
    icon: <TbInfoTriangleFilled size={14} />,
    path: "/term-and-conditions",
    component: <TermConditions />,
    isAuthenticated: true,
    label: "Term and Conditions",
    permission: "privacy policies",
  },
  // {
  //   link: "/terms-conditions?page=1",
  //   icon: <TbInfoTriangleFilled size={14} />,
  //   path: "/terms-conditions",
  //   component: <TermsAndConditions />,
  //   isAuthenticated: true,
  //   label: "Terms and Conditions",
  //   permission: "terms_conditions",
  // },
  // {
  //   link: "/faqs",
  //   icon: <FaQuestion size={14} />,
  //   path: "/faqs",
    // component: <Faqs />,
  //   isAuthenticated: true,
  //   label: "Faqs",
  //   permission: "faqs",
  // },
  {
    
      link: "/createrole",
      icon: <RiAdminFill size={18} />,
      path: "/createrole",
      component: <CreateRole />,
      isAuthenticated: true,
      label: "Create Role",
      permission: "role",
    },
  
    ,
    // {
    //   link: "/createuser",
    //   icon: <FaQuestion size={14} />,
    //   path: "/createuser",
    //   component: <CreateUser />,
    //   isAuthenticated: true,
    //   label: "Create User",
    //   permission: "role",
    // },
    {
      link: "/chat",
      icon: <MdOutlineHelpCenter size={18} />,
      path: "/chat",
      component: <HelpCenter />,
      isAuthenticated: true,
      label: "Tech Support",
      permission: "support",
    },
    // {
  // {
  //   link: "/createuser",
  //   icon: <FaQuestion size={14} />,
  //   path: "/createuser",
  //   component: <CreateUser />,
  //   isAuthenticated: true,
  //   label: "Create User",
  //   permission: "role",
  // },
  {
    link: "/notification",
    icon: <IoNewspaperSharp size={18} />,
    path: "/notification",
    component: <NotificationPage />,
    isAuthenticated: true,
    label: "Notification",
    permission: "notification"
  },
  {
    link: "/category-subcategory",
    icon: <BiCategory size={18} />,
    path: "/category-subcategory",
    component: <CategorySubcategory />,
    isAuthenticated: true,
    label: "Category/Subcategory",
    permission: "category subcategory",
  },
  {
    link: "/faq",
    icon: <FaQuestion size={18} />,
    path: "/faq",
    component: <Faq />,
    isAuthenticated: true,
    label: "FAQ",
    permission: "faq",
  },
  {
    link: "/human-coach",
    icon: <FaUsers size={18} />,
    path: "/human-coach",
    component: <Chat />,
    isAuthenticated: true,
    label: "Ponderiee style coach",
    permission: "human coach",
  },
  {
    link: "/coach-history",
    icon: <FaCalendarAlt size={18} />,
    path: "/coach-history",
    component: <CoachHistory />,
    isAuthenticated: true,
    label: "Coach History",
    permission: "coach history",
  },
  {
    link: "/subscriptions",
    icon: <FaCreditCard size={18} />,
    path: "/subscriptions",
    component: <Subscriptions />,
    isAuthenticated: true,
    label: "Subscriptions",
    permission: "subscriptions",
  },
];
